import type {
  ScalesReadingDto,
  TransformedScalesReading,
} from './dto/ScalesReadingDto'

export class ScalesReadingError extends Error {}

/**
 * @throws {ScalesReadingError} Не удалось корректно прочитать полученные данные
 */
export const transformScalesReading: (
  data: string,
) => TransformedScalesReading = (data) => {
  try {
    const dataJson = JSON.parse(data) as Partial<ScalesReadingDto>
    const result: TransformedScalesReading = {
      createdAt: validateCreatedAt(dataJson?.createdAt),
      value: validateValue(dataJson?.value),
    }
    return result
  } catch (e) {
    throw new ScalesReadingError('Получены некорректные данные')
  }
}

/**
 * @throws {ScalesReadingError} Не удалось корректно прочитать дату показаний весов
 */
function validateCreatedAt(createdAt?: string): number {
  const errorPrefix =
    'Получено некорректное значение даты замера показаний весов'
  if (typeof createdAt !== 'string') {
    throw new ScalesReadingError(`${errorPrefix} - ожидается строка`)
  }
  try {
    return new Date(createdAt).getTime()
  } catch (e) {
    if (e instanceof RangeError) {
      throw new ScalesReadingError(
        `${errorPrefix} - ожидается строка в формате ISO 8601`,
      )
    }
    throw e
  }
}

/**
 * @throws {ScalesReadingError} Не удалось корректно прочитать значение показаний весов
 */
function validateValue(value?: number): number {
  const errorPrefix = 'Получено некорректное значение показаний весов'

  if (typeof value !== 'number') {
    throw new ScalesReadingError(`${errorPrefix} - ожидается число`)
  }
  return value
}
